import { PlusOutlined } from '@ant-design/icons';
import PageToolbar from 'ui/PageToolbar/PageToolbar';
import React, { useState } from 'react';
import { useQuery } from '@apollo/client';
import { Button } from 'antd';
// Api
import { GET_TRANSITIONS } from 'api/video-merge-job/queries';
// Types
import {
  GetTransitions,
  GetTransitions_getTransitions,
} from 'api/video-merge-job/types/GetTransitions';
// UI
import Table from 'ui/Table';
// Components
import Actions from './components/Actions';
import CreateEditTransitionModal from './components/CreateEditTransitionModal';

import styles from './InterviewNowTransitions.module.scss';

const InterviewNowTransitions: React.FC = () => {
  const [createEditModalVisible, setCreateEditModalVisible] =
    useState<boolean>(false);
  const [selectedRecord, setSelectedRecord] =
    useState<GetTransitions_getTransitions | null>(null);
  const [isEditModalVisible, setIsEditModalVisible] = useState<boolean>(false);

  const { data, loading, refetch } = useQuery<GetTransitions>(GET_TRANSITIONS, {
    fetchPolicy: 'cache-and-network',
  });

  const handleShowAddTransitionModal = () => {
    setSelectedRecord(null);
    setIsEditModalVisible(false);
    setCreateEditModalVisible(true);
  };

  const handleShowEditTransitionModal = (
    record: GetTransitions_getTransitions
  ) => {
    setSelectedRecord(record);
    setIsEditModalVisible(true);
    setCreateEditModalVisible(true);
  };

  const closeCreateEditModal = () => {
    setCreateEditModalVisible(false);
    setSelectedRecord(null);
    setIsEditModalVisible(false);
    refetch();
  };

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      fixed: 'left' as const,
      align: 'left' as const,
      width: 200,
    },
    {
      title: 'Type',
      dataIndex: 'type',
      key: 'type',
      align: 'left' as const,
      width: 150,
      render: (type: string) => type,
    },
    {
      title: 'Is Active',
      dataIndex: 'isActive',
      key: 'isActive',
      align: 'center' as const,
      width: 100,
      render: (isActive: boolean) => (isActive ? 'Yes' : 'No'),
    },
    {
      title: 'Actions',
      dataIndex: 'id',
      fixed: 'right' as const,
      align: 'center' as const,
      width: 75,
      render: function ActionsWrap(
        id: string,
        record: GetTransitions_getTransitions
      ) {
        return (
          <Actions
            transition={record}
            onEdit={handleShowEditTransitionModal}
            onDelete={refetch}
          />
        );
      },
    },
  ];

  return (
    <>
      <div className={styles.root}>
        <PageToolbar>
          <Button
            icon={<PlusOutlined />}
            type="primary"
            onClick={handleShowAddTransitionModal}
          >
            Add new transition
          </Button>
        </PageToolbar>

        <Table<GetTransitions_getTransitions>
          columns={columns}
          data={data?.getTransitions}
          scroll={{ x: 400 }}
          loading={loading}
        />
      </div>

      <CreateEditTransitionModal
        isVisible={createEditModalVisible}
        isEdit={isEditModalVisible}
        record={selectedRecord}
        onClose={closeCreateEditModal}
        refetchTransitions={refetch}
      />
    </>
  );
};

export default InterviewNowTransitions;
